import React, { createContext, useContext, useState, useEffect } from 'react';

interface BranchContextType {
  selectedBranch: string;
  setSelectedBranch: (branchId: string) => void;
}

const BranchContext = createContext<BranchContextType | undefined>(undefined);

export const BranchProvider: React.FC<{ children: React.ReactNode; userRole: string }> = ({ 
  children, 
  userRole 
}) => {
  const [selectedBranch, setSelectedBranch] = useState<string>(() => {
    // Load from localStorage or default
    const saved = localStorage.getItem('selectedBranch');
    return saved || (userRole === 'superadmin' ? 'all' : 'kolkata');
  });

  useEffect(() => {
    // Save to localStorage whenever it changes
    localStorage.setItem('selectedBranch', selectedBranch);
  }, [selectedBranch]);

  return (
    <BranchContext.Provider value={{ selectedBranch, setSelectedBranch }}>
      {children}
    </BranchContext.Provider>
  );
};

export const useBranch = () => {
  const context = useContext(BranchContext);
  if (context === undefined) {
    throw new Error('useBranch must be used within a BranchProvider');
  }
  return context;
};
